// extracted by mini-css-extract-plugin
export var RelativeWrapper = "fullscreen-background-module--RelativeWrapper--o62l6";
export var BackgroundWrapper = "fullscreen-background-module--BackgroundWrapper--zrc-Z";
export var ForegroundWrapper = "fullscreen-background-module--ForegroundWrapper--F1xB8";
export var NonInteractive = "fullscreen-background-module--NonInteractive--5QxGA";
export var ContentWrapper = "fullscreen-background-module--ContentWrapper--ZSC6F";
export var OnTop = "fullscreen-background-module--OnTop--TCsd1";